import router from '../router'
import Vue from 'vue'
let $util = {

  getlocalStorage(name) {
    let obj = localStorage.getItem(name)
    if (obj != null && obj != '' && obj != undefined && obj != 'undefined') {
      return JSON.parse(obj)
    }
    return null;
  },
  setlocalStorage(name, value) {
    localStorage.setItem(name, JSON.stringify(value))
  },
  removelocalStorage(name) {
    localStorage.removeItem(name);
  },
  getAreaName: (code, flag) => {
    let name = this.getlocalStorage('AREA_OBJ')[code]
    if (flag) {
      name = name.replace("省", "")
      name = name.replace("市", "")
      name = name.replace("自治区", "")
      name = name.replace("特别行政区", "")
    }
    if (code == 450000) {
      name = '广西'
    } else if (code == 640000) {
      name = '宁夏'
    } else if (code == 650000) {
      name = '新疆'
    }
    return name;
  },
  showcode: (year) => {
    return localStorage.getItem('showcode')
  },
  getShowYear: () => {
      if (new Date().getMonth()>9) {
        return new Date().getFullYear()+1;
      } else {
        return new Date().getFullYear();
      }
  },
  getAreaCodeByName: (name) => {
    let list = JSON.parse(localStorage.getItem('AREA_OBJ'))
    name = name.replace("省", "")
    name = name.replace("市", "")
    name = name.replace("自治区", "")
    name = name.replace("特别行政区", "")
    if (name.indexOf('广西') != -1) {
      name = '广西'
    } else if (name.indexOf('宁夏') != -1) {
      name = '宁夏'
    } else if (name.indexOf('新疆') != -1) {
      name = '新疆'
    }
    for (let o in list) {
      if (list[o] == name) {
        return o
      }
    }
    return 370000;
  },
  getAreaFullName(code) {
    let name = JSON.parse(localStorage.getItem('AREA_OBJ'))[code]
    if (code == 450000) {
      name = '广西壮族自治区'
    } else if (code == 640000) {
      name = '宁夏回族自治区'
    } else if (code == 650000) {
      name = '新疆维吾尔族自治区'
    } else if (code == 150000) {
      name = '内蒙古自治区'
    } else if (code == 540000) {
      name = '西藏自治区'
    } else if (code == 110000 || code == 120000 || code == 310000 || code == 500000) {
      name = name + "市"
    } else if (code == 810000 || code == 820000) {
      name = name + "特别行政区"
    } else {
      name = name + "省"
    }
    return name;
  },
  getrateStyle(rate, n) {
    var vm = new Vue()
    let color = '';
    if (rate <= vm.$rate.fxg) {
      color = '#de3f34';
    } else if (rate > vm.$rate.fxg && rate <= vm.$rate.cyc) {
      color = '#FF513E';
    } else if (rate > vm.$rate.cyc && rate <= vm.$rate.wyw) {
      color = '#fe9b0e';
    } else if (rate > vm.$rate.wyw && rate <= vm.$rate.byb) {
      color = '#0081cc';
    } else if (rate > vm.$rate.byb) {
      color = '#00B54F';
    }
    if (n) {
      return {
        background: color
      };
    } else {
      return {
        color: color
      };
    }

  },
  getHeardrList(tianbaoType, showtype) {
    if (tianbaoType == 0) {
      if (showtype == 'majorscore') {
        return [8, 21, 5, 5, 6, 5, 12, 5, 25, 8]
      }
      return [10, 21, 5, 5, 6, 5, 8, 5, 26, 9]
    } else if (tianbaoType == 1) {
      let userInfo = this.getlocalStorage('userInfo')
      if (parseInt(userInfo.userRole) >= 2 && parseInt(userInfo.userRole) != 4) {
        return [7, 20, 4, 4, 4, 4, 11, 4, 30, 8, 4]
      } else {
        return [7, 20, 4, 5, 6, 4, 13, 4, 25, 8, 4]
      }
    } else if (tianbaoType == 2) {
      if (showtype == 'majorscore') {
        return [7, 20, 4, 4, 6, 4, 14, 4, 25, 8, 4]
      }
      return [7, 20, 5, 5, 6, 5, 9, 5, 25, 8, 5]
    }
  },
  getHeardrListfen(tianbaoType, typename) {
    if (tianbaoType == 0) {
      if (typename == 'collegescore') {
        return [24, 5, 5, 8, 5, 10, 6, 28, 9]
      } else {
        return [24, 5, 5, 6, 5, 16, 5, 26, 8]
      }
    } else if (tianbaoType == 1) {
      return [20, 5, 5, 8, 5, 14, 5, 24, 8, 6]
    } else if (tianbaoType == 2) {
      if (typename == 'collegescore') {
        return [24, 5, 5, 8, 5, 10, 5, 24, 8, 6]
      } else {
        return [20, 5, 5, 8, 5, 14, 5, 24, 8, 6]
      }
    }
  },

  getscore(list, scoreYear) {
    let _this = this;
    let listr = []
    let ad = {
      scoreYear: "-",
      scorePlanNum: "-",
      scoreMin: "-",
      scoreMinRank: "-",
      scoreXiancha: '-'
    };
    if (list != null) {
      if (list.length < 3) {
        if (list.length == 2) {
          if (list[0].scoreYear == scoreYear) {
            listr.push(list[0])
            if (list[1].scoreYear == scoreYear - 1) {
              listr.push(list[1])
              listr.push(ad)
            } else {
              listr.push(ad)
              listr.push(list[1])
            }
          } else {
            listr.push(ad)
            listr.push(list[0])
            listr.push(list[1])
          }
        } else if (list.length == 1) {
          if (list[0].scoreYear == scoreYear) {
            listr.push(list[0])
            listr.push(ad)
            listr.push(ad)

          } else if (list[0].scoreYear == scoreYear - 1) {
            listr.push(ad)
            listr.push(list[0])
            listr.push(ad)
          } else if (list[0].scoreYear == scoreYear - 2) {
            listr.push(ad)
            listr.push(ad)
            listr.push(list[0])
          }
        }
      } else {
        listr.push(list[0])
        listr.push(list[1])
        listr.push(list[2])
      }
    } else {
      listr.push(ad)
      listr.push(ad)
      listr.push(ad)
    }
    return listr;

  },

  showflag(str) {
    if (str != null && str != '') {
      return true;
    }
    return false;
  },
  show__(str) {
    if (str != null && str != '') {
      return str;
    }
    return '--';
  },
  getCollegeLevel(level) {
    if (level == "" || level == null) {
      return "";
    }
    let list = level.split("、")
    let _this = this;
    let str = ""
    list.forEach(function(item) {
      str += _this.getCollegeLevelName(item)
    })
    return str.substring(0, str.length - 1);
  },
  getCollegeLevelName(level) {
    let str = "";
    if (level == "985") {
      str += "985/"
    }
    if (level == "211") {
      str += "211/"
    }
    if (level.indexOf("全国重点大学") != -1) {
      str += "国重点/"
    }
    if (level.indexOf("北京市重点建设大学") != -1) {
      str += "北京市重点/"
    }
    if (level.indexOf("双一流学科") != -1) {
      str += "双一流/"
    }
    if (level.indexOf("双一流B类") != -1) {
      str += "双一流A/"
    }
    if (level.indexOf("双一流B类") != -1) {
      str += "双一流B/"
    }

    if (level.indexOf("研究生院") != -1) {
      str += "研究生院/"
    }
    if (level.indexOf("省属共建院校") != -1) {
      str += "省属共建/"
    }
    if (level.indexOf("省属重点大学") != -1) {
      str += "省重点/"
    }
    if (level.indexOf("全国重点艺术院校") != -1) {
      str += "重点艺术/"
    }
    if (level == '博士' || level == '硕士' || level == '本科') {
      str += ""
    }
    return str.substring(0, str.length - 1);
  },
  getTinbaoAlert(map, item, btntype) {
    var vm = new Vue()
    //btntype 0:选择志愿  1:生成志愿单
    let res = null;
    let type = this.getlocalStorage("selectZhiYuanType")
    let batch = this.getlocalStorage("userZhiYuanBatch")
    let cyc = this.getlocalStorage("ZhiYuancyc").ids.length
    let wyw = this.getlocalStorage("ZhiYuanwyw").ids.length
    let byb = this.getlocalStorage("ZhiYuanbyb").ids.length
    let dyd = this.getlocalStorage("ZhiYuandyd").ids.length
    let tianbaoType = this.getlocalStorage("tianbaoType");
    let ZhiYuanSun = this.getlocalStorage("ZhiYuanSun")
    let scoreInfo = this.getlocalStorage("scoreInfo")
    let sun = cyc + wyw + byb + dyd
    let xuancha = parseInt(scoreInfo.score) - batch.provincialScore

    let str = '冲一冲';
    let str2 = '稳一稳';
    let str3 = 'wyw'
    if (type == 'wyw') {
      str = '稳一稳'
      str2 = '保一保'
      str3 = 'byb'
    } else if (type == 'byb') {
      str = '保一保'
      str2 = '垫一垫'
      str3 = 'dyd'
    } else if (type == 'dyd') {
      str = '垫一垫'
      str2 = '';
    }
    if (tianbaoType == 0) {
      cyc = 0;
      wyw = 0;
      byb = 0;
      dyd = 0;
      let map = this.getlocalStorage("ZhiYuancyc").map
      for (let o in map) {
        if (map[o].rate <= vm.$rate.cyc) {
          cyc++;
        } else if (map[o].rate > vm.$rate.cyc && map[o].rate <= vm.$rate.wyw) {
          wyw++;
        } else if (map[o].rate > vm.$rate.wyw && map[o].rate <= vm.$rate.byb) {
          byb++;
        } else if (map[o].rate > vm.$rate.byb) {
          dyd++;
        }
      }
      sun = Object.keys(map).length
    }
    //稳一稳有数据 志愿必须选择
    if (ZhiYuanSun.sun_wyw != 0 && btntype == 1) {
    	if (wyw == 0) {
    		res = {}
    		res.msgType = 'error'
    		res.title = '风险警告'
    		res.content = '“稳一稳”中有推荐志愿，您未选择，“稳一稳”中志愿录取可能性特别大，为了志愿合理性，请去选择“稳一稳”志愿';
    		res.type = 1
    		res.to = 'wyw'
    		res.flag = true
    		res.quxiaoName = "去“稳一稳”";
    		res.quitName = "生成志愿单";
    		return res;
    	}
    	if (tianbaoType != 0) {
    		//稳一稳  有最低数限制
    		if (wyw < batch['wywti'] && ZhiYuanSun.sun_wyw >= batch['wywti']) {
    			res = {}
    			res.msgType = 'error'
    			res.title = '风险警告'
    			res.content = '“稳一稳”中至少选择' + batch['wywti'] + '个志愿，您选择了' + wyw + '，请去“稳一稳”中继续完善志愿';
    			res.type = 1
    			res.to = 'wyw'
    			res.quxiaoName = "去“稳一稳”";
    			res.quitName = "生成志愿单";
    			res.flag = true
    			return res;
    		}
    	}
    }
    //保一保中有数据
    if (ZhiYuanSun.sun_byb != 0 && btntype == 1) {
    	//必须选择志愿
    	if (byb < batch['bybti'] && ZhiYuanSun.sun_byb >= batch['bybti']) {
    		res = {}
    		res.msgType = 'error'
    		res.title = '风险警告'
    		res.content = '“保一保”中有推荐志愿，您未选择，“保一保”中志愿录取可能性较大，为了志愿合理性，请去选择“保一保”志愿';
    		res.type = 1
    		res.to = 'byb'
    		res.quxiaoName = "去“保一保”";
    		res.quitName = "生成志愿单";
    		res.flag = true
    		return res;
    	}
    }

    if (ZhiYuanSun.sun_dyd != 0 && btntype == 1) {
    	//必须选择志愿
    	if (dyd < batch['dydti'] && ZhiYuanSun.sun_dyd >= batch['dydti']) {
    		res = {}
    		res.msgType = 'error'
    		res.title = '风险警告'
    		res.content = '“垫一垫”中有推荐志愿，您未选择，“垫一垫”中志愿为您的最后保底志愿，为了志愿合理性，请去选择“垫一垫”志愿，并且录取概率最高的志愿尽量选择一个或一个以上';
    		res.type = 1
    		res.to = 'dyd'
    		res.quxiaoName = "去“垫一垫”";
    		res.quitName = "生成志愿单";
    		res.flag = true
    		return res;
    	}
    }



    if (sun == batch.provincialNum + 1 || sun == batch.provincialNum + 5 || sun == batch.provincialNum + 10 ||
    	btntype == 1) {
    	res = {}
    	// let n = tianbaoType == 0 ? 3 : 10;
    	res.msgType = 'warn';
    	res.title = '友情提醒';
    	res.content = '考试院规定本批次志愿数为' + batch.provincialNum +
    		'个，您已选择' + sun + '个，系统可选择多于' + batch.provincialNum + '个，你是否继续选择？';

    	// if(btntype == 0){
    	res.quxiaoName = "继续选择";
    	res.quxiaofun = "openmajor";
    	res.quitName = "生成志愿单";
    	res.type = 2;
    	res.toastObj = {
    		flag: true
    	}
    	res.fun = 'openyixuan'

    	// }
    	if (btntype == 1) {
    		res.quxiaoName = "继续选择";
    		res.quxiaofun = "";
    	}
    	// res.type = 1;
    	// if (sun >= batch.provincialNum + n && btntype == 0) {
    	//   res.flag = true;
    	// }
    }
    return res;
  },

  getqueryKey(queryObj,userRole,userId){
    let keys = '{userArea='+queryObj.userArea+', userScore='+queryObj.userScore+', batch='+queryObj.batch+
    ', tianbaoType='+queryObj.tianbaoType+', tianbaoGrade=, scoretype='+queryObj.scoretype+', xk1='+queryObj.xk1+
    ', xk2='+queryObj.xk2+', xk3='+queryObj.xk3;

    //keys+=this.getObjectItem(queryObj,'down')
    if(queryObj.down!=null&&queryObj.down!=''){
      keys+= ", downScore="+queryObj.down
    }

    if(queryObj.majorids!=null&&queryObj.majorids!=''){
      keys+= ", majorids="+queryObj.majorids
    }
    if(userRole == 3||userRole == 2){
      keys+=', userId='+userId
    }
    let keysadd="";
    keysadd+=this.getObjectItem(queryObj,'collegeAreas');
    keysadd+=this.getObjectItem(queryObj,'collegeLevel');
    keysadd+=this.getObjectItem(queryObj,'collegeName');
    keysadd+=this.getObjectItem(queryObj,'collegeNature');
    keysadd+=this.getObjectItem(queryObj,'collegeSubject');
    keysadd+=this.getObjectItem(queryObj,'collegeSubjection');
    keysadd+=this.getObjectItem(queryObj,'majorInfo');
    keysadd+=this.getObjectItem(queryObj,'majorName');
    if(keysadd!=""){
      keysadd+=this.getObjectItem(queryObj,'data_type');
    }
    return {keys:keys+'}', keyadd:keys +keysadd+'}'};
  },
  getObjectItem(queryObj,item){
    if(queryObj[item]!=null&&queryObj[item]!=''){
      return ", "+item+"="+queryObj[item]
    } else {
      delete queryObj[item]
      return ""
    }
  },

  getScorecolor(user,college,type){
    if(college!=null&&college!='--'&&college!='-'){
        let collegen = parseFloat(college)
        let usern = parseFloat(user)
        if(type == 0 ){
          if(usern>college){return '#F53824'};
        } else {
          if(usern<college){return '#F53824'};
        }
    }
    return 'rgb(5, 232, 5)';
  },
  getScoreCha(user,college,type,){
    console.log(user)
    console.log(college)
    console.log(college!=null&&college!='--'&&college!='-')
    if(college!=null&&college!='--'&&college!='-'){
      let usern = parseFloat(user)
      let collegen = parseFloat(college)
      if(type == 0 ){
        return collegen-usern;
      } else {
        return usern - collegen;
      }
    }
    return '--';

  },




  getUserXuanKe(userSelect) {
    let str = "";
    if (userSelect.indexOf('wl') != -1) {
      str += "物理/"
    }
    if (userSelect.indexOf('ls') != -1) {
      str += "历史/"
    }
    if (userSelect.indexOf('hx') != -1) {
      str += "化学/"
    }
    if (userSelect.indexOf('sw') != -1) {
      str += "生物/"
    }
    if (userSelect.indexOf('dl') != -1) {
      str += "地理/"
    }
    if (userSelect.indexOf('zz') != -1) {
      str += "政治/"
    }
    if (userSelect.indexOf('xxjs') != -1) {
      str += "信息技术/"
    }
    return str.substring(0, str.length - 1);
  },
  getZyShowXuanKe(obj) {
    let str = "";
    let str1 = "";
    let strsd = "";
    let m = 0;
    let a = "/";
    if (obj.andor == 1) {
      a = "+";
    }
    //xingaokao2  3+1+2 专业组
    //xingaokao3  3+3   专业组 北京
    //xingaokao4  3+1+2 单专业
    //xingaokao5  3+3   单专业
    //xingaokao6  3+4   单专业

    // if (this.getlocalStorage("xuankeArea").xingaokao2.indexOf(this.getlocalStorage("areaInfo").areaName) != -1 ||
    //   this.getlocalStorage("xuankeArea").xingaokao4.indexOf(this.getlocalStorage("areaInfo").areaName) != -1) {

    //   if (obj.wl == 1) {
    //     str += "物+";
    //     str1 = "物理+";
    //     strsd += "物" + a;
    //     m++;
    //   }
    //   if (obj.ls == 1) {
    //     str += "历+";
    //     str1 = "历史+";
    //     strsd += "历" + a;
    //     m++;
    //   }

    // }







    if (obj.wl == 1) {
      str += "物+";
      str1 = "物理+";
      strsd += "物" + a;
      m++;
    }
    if (obj.ls == 1) {
      str += "历+";
      str1 = "历史+";
      strsd += "历" + a;
      m++;
    }
    if (m == 2) {
      str = "不限";
      str1 = "不限+";
    }

    let n = 0;
    let str2 = "";
    let str3 = "";
    if (obj.sw == 1) {
      str2 += "生" + a;
      str3 = "生物";
      strsd += "生" + a;
      n++;
    }
    if (obj.hx == 1) {
      str2 += "化" + a;
      str3 = "化学";
      strsd += "化" + a;
      n++;
    }
    if (obj.dl == 1) {
      str2 += "地" + a;
      str3 = "地理";
      strsd += "地" + a;
      n++;
    }
    if (obj.zz == 1) {
      str2 += "政" + a;
      str3 = "政治";
      strsd += "政" + a;
      n++;
    }
    if (this.getlocalStorage("xuankeArea").xingaokao6.indexOf(this.getlocalStorage("areaInfo").areaName) != -1) {
      if (obj.xxjs == 1) {
        str2 += "信" + a;
        str3 = "信息技术";
        strsd += "信" + a;
        n++;
      }
      if (m + n == 7) {
        return "不限";
      }
      return strsd.substring(0, strsd.length - 1);
    }
    if (this.getlocalStorage("xuankeArea").xingaokao3.indexOf(this.getlocalStorage("areaInfo").areaName) != -1 ||
      this.getlocalStorage("xuankeArea").xingaokao5.indexOf(this.getlocalStorage("areaInfo").areaName) != -1) {
      if (m + n == 6) {
        return "不限";
      } else if (m + n == 1) {
        if (m == 1) {
          return str1;
        } else {
          return str3;
        }
      }
      return strsd.substring(0, strsd.length - 1);
    }


    if (n == 1) {
      return str3;
    } else if (n == 4) {
      return "不限";
    }
    return "(" + str2.substring(0, str2.length - 1) + ")";
  },
  getXuanKeString(obj) {
    let str = "";
    if (userSelect.indexOf('wl') != -1) {
      str += "物理/"
    }
    if (userSelect.indexOf('ls') != -1) {
      str += "历史/"
    }
    if (userSelect.indexOf('hx') != -1) {
      str += "化学/"
    }
    if (userSelect.indexOf('sw') != -1) {
      str += "生物/"
    }
    if (userSelect.indexOf('dl') != -1) {
      str += "地理/"
    }
    if (userSelect.indexOf('zz') != -1) {
      str += "政治/"
    }
    if (userSelect.indexOf('xxjs') != -1) {
      str += "信息技术/"
    }
    return str.substring(0, str.length - 1);
  },
  tologin(_this) {
    if (this.getlocalStorage("userInfo") != null && this.getlocalStorage("userInfo") != "") {
      return true;
    } else {
      _this.$alert('请登录后在使用该功能', {
        confirmButtonText: '去登录',
        callback: action => {
          if (action == 'confirm') {
            _this.$router.push('/login')
          }
        }
      })
      return;
    }
  },
  getLoginStatus(_this) {
    console.log('2323')
    if (this.getlocalStorage("userInfo") == null || this.getlocalStorage("userInfo") == "") {
      router.push('/login')
      return false;
    } else {
      if (!this.getPhoneStatus(_this)) {
        return false;
      }
      if (!this.getUserInfostatus(_this)) {
        return false;
      }
      return true;
    }
  },
  getFenshu(_this) {
    if (this.getlocalStorage('scoreInfo') != null && this.getlocalStorage('scoreInfo') != "" && this.getlocalStorage(
        'scoreInfo').score + '' != '0') {
      let distime = new Date(this.getlocalStorage('disTime'))
      let newtime = new Date()
      console.log(distime <= newtime)
      //当前时间大于锁分时间
      if (this.getlocalStorage('disTime') != null && this.getlocalStorage('disTime') != '') {
        if (distime <= newtime && this.getlocalStorage('scoreInfo').islock == 0 && this.getlocalStorage('userInfo')
          .userRole != 3) {
          router.push('/grzx_wdfs')
        } else {
          return true;
        }
      } else {
        return true;
      }
    } else {
      if (_this.userInfo.userRole != '3' && _this.userInfo.userRole != '2') {
        _this.$alert('请输入完善分数信息再使用', {
          confirmButtonText: '确定',
          callback: action => {
            if (action == 'confirm') {
              router.push('/grzx_wdfs')
            }
          }
        })
      } else {
        _this.$alert('请完善学生信息再使用', {
          confirmButtonText: '确定',
          callback: action => {
            if (action == 'confirm') {
              router.push('/grzx_wdxs')
            }
          }
        })
      }

      return false;
    }
  },
  getUserInfo(_this) {
    if (this.getlocalStorage('userInfo') != null && this.getlocalStorage('userInfo') != "" &&
      this.getlocalStorage('userInfo').userProvinces != null && this.getlocalStorage('userInfo').userProvinces != ""
    ) {
      return true;
    } else {
      if (this.getlocalStorage('memberInfo').cardType == 3) {
        return true;
      } else {
        _this.$alert('请输入完善个人信息再使用', {
          confirmButtonText: '确定',
          callback: action => {
            if (action == 'confirm') {
              router.push('/gerenzhongxin')
            }
          }
        })
      }

      return false;
    }
  },
  getuserCang(_this, type) {
    let cang = 0
    if (type == 'college' || type == 'major') {
      cang = this.getlocalStorage('userCang')[type].length
    } else {
      cang = this.getlocalStorage('userCang')['collegescore'].length + this.getlocalStorage('userCang')['majorscore']
        .length
    }
    if (cang != 0) {
      return true;
    } else {
      let str = ''
      let url = ''
      if (type == 'college') {
        str = '您未收藏任何院校请到“院校资源”添加'
        url = '/zyf'
      } else if (type == 'major') {
        str = '您未收藏任何专业请到“专业资源”添加'
        url = '/zhuanyezhiyuan'
      }
      _this.$alert(str, {
        confirmButtonText: '确定',
        callback: action => {
          if (action == 'confirm') {
            router.push(url)
          }
        }
      })
      return false;
    }
  },
  getPhoneStatus(_this) {
    if (this.getlocalStorage("userInfo").userPhone == null || this.getlocalStorage("userInfo").userPhone == "") {
      _this.$alert('请输入完善手机信息再使用', {
        confirmButtonText: '确定',
        callback: action => {
          if (action == 'confirm') {
            router.push('/grzx_xougaimima')
          }
        }
      })
      return false;
    } else {
      return true;
    }
  },
  getUserInfostatus(quxiaourl) {
    if (this.getlocalStorage("userInfo").userName == null || this.getlocalStorage("userInfo").userName == '') {

      uni.navigateTo({
        url: '/pages/login/modify'
      })
      // let message = {
      // 	msgType: "error",
      // 	title: "提示",
      // 	content: "请先完善用户信息再操作",
      // 	url: "/pages/login/modify",
      // 	quxiaourl: quxiaourl,
      // }
      // // #ifdef APP-PLUS
      // uni.navigateTo({
      // 	url: '/pages/popup/popup?message=' + encodeURIComponent(JSON.stringify(message))
      // })
      // // #endif
      // // #ifndef APP-PLUS
      // uni.showModal({
      // 	title: message.title,
      // 	content: message.content,
      // 	cancelText: "取消",
      // 	confirmText: "去完善",
      // 	success(res) {
      // 		if (res.confirm) {
      // 			uni.navigateTo({
      // 				url: '/pages/login/modify'
      // 			})
      // 		} else if (res.cancel) {
      // 			if (quxiaourl != null && quxiaourl != "") {
      // 				uni.switchTab({
      // 					url: "/pages/index/index"
      // 				})
      // 			}
      // 			console.log('用户点击取消')
      // 		}
      // 	}
      // });
      // #endif
      return false;
    }
    return true;


  },

  getUserScorestatus(quxiaourl) {
    if (this.getlocalStorage("scoreInfo") == null && this.getlocalStorage("scoreInfo") == "") {
      uni.navigateTo({
        url: '/pages/mine/bianji'
      })
      // let message = {
      // 	msgType: "error",
      // 	title: "提示",
      // 	content: "请先完善用户成绩再操作",
      // 	url: "/pages/mine/bianji",
      // 	quxiaourl: quxiaourl,
      // }
      // // #ifdef APP-PLUS
      // uni.navigateTo({
      // 	url: '/pages/popup/popup?message=' + encodeURIComponent(JSON.stringify(message))
      // })
      // // #endif
      // // #ifndef APP-PLUS
      // uni.showModal({
      // 	title: message.title,
      // 	content: message.content,
      // 	cancelText: "取消",
      // 	confirmText: "去完善",
      // 	success(res) {
      // 		if (res.confirm) {
      // 			uni.navigateTo({
      // 				url: '/pages/mine/bianji'
      // 			})
      // 		} else if (res.cancel) {
      // 			if (quxiaourl != null && quxiaourl != "") {
      // 				uni.switchTab({
      // 					url: "/pages/index/index"
      // 				})
      // 			}
      // 			console.log('用户点击取消')
      // 		}
      // 	}
      // });
      // #endif

      return false;
    } else {
      return true;
    }
  },

  regphone(phone) {
    let reg = /^[1][2,3,4,5,6,7,8,9][0-9]{9}$/;
    return reg.test(phone)
  }
}

export default $util;



// WEBPACK FOOTER //
// ./src/libs/util.js